// Campus photo for /colleges/university-of-vermont: CC0 1.0, by HeyTomek, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AUniversity_of_Vermont_Old_Mill.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-vermont/; credited under the photo.
const photo = {
    "slug": "university-of-vermont",
    "alt": "The red brick Old Mill building and its tower above the University Green at the University of Vermont in Burlington",
    "src": "/colleges/university-of-vermont/campus-1600.webp",
    "srcSmall": "/colleges/university-of-vermont/campus-800.webp",
    "srcMid": "/colleges/university-of-vermont/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-vermont/og.jpg",
    "title": "University of Vermont Old Mill",
    "author": "HeyTomek",
    "license": "CC0 1.0",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AUniversity_of_Vermont_Old_Mill.jpg",
    "read": "2026-10-02"
};

export default photo;
